import { makeStyles, IconButton } from '@material-ui/core'
import { useDropzone } from 'react-dropzone'
import clsx from 'clsx'
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import { useEffect, useState } from 'react'
import PublishIcon from '@material-ui/icons/Publish'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles((theme) => ({
  dropzone: {
    border: '1px dashed #d9d9d9',
    backgroundColor: 'white',
    width: '100%',
    minHeight: 120,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  fileBox: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid black',
    width: 240,
  },
  uploadText: {
    fontSize: 16,
  },
  greyText: {
    color: '#828282',
  },
  fileNameArea: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  fileName: {
    marginLeft: theme.spacing(1),
    fontWeight: 500,
  },
  colorRed: {
    color: 'red',
  }
}))

const Uploader = ({ filesState, setFilesState, setUploaderError}) => {
  const classes = useStyles()
  const [isDiabled, setDisabled] = useState(false)
  const [recentRejectedFile, setRecentRejectedFile] = useState(null)

  const { t } = useTranslation('common')

  const errorMessage = (code) => {
    switch(code) {
      case 'file-too-large':
        return t('uploader.file-too-large')
      case 'file-invalid-type':
        return t('uploader.file-invalid-type')
      default:
        return t('uploader.an-error-occured')
    }
  }

  const handleFileDrop = (acceptedFiles) => {
    let newFiles = [...filesState, ...acceptedFiles]
    setFilesState(newFiles)
  }

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    onDrop: handleFileDrop,
    maxSize: 1024 * 1024 * 5,
    maxFiles: 1,
    disabled: isDiabled,
    accept: '.jpg, .jpeg, .png, .pdf',
  })

  useEffect(() => {
    setRecentRejectedFile(fileRejections[0])
    setUploaderError(true)
  },[fileRejections])

  useEffect(() => {
    if (filesState.length >= 1 || recentRejectedFile) setDisabled(true)
    else setDisabled(false)

    if (!recentRejectedFile) setUploaderError(false)

  },[filesState,recentRejectedFile])

  return (
    <section>
      <div {...getRootProps({ className: classes.dropzone })}>
        <input {...getInputProps()} />
        {!recentRejectedFile && (filesState.length <= 0 ? (
          <>
            <PublishIcon className={classes.greyText} />
            <span className={clsx(classes.uploadText,classes.greyText)}>{t('uploader.desc')}</span>
          </>
        ) : (
          filesState.map((file) => (
            <div className={classes.fileNameArea} key={file.name}>
              <InsertDriveFileOutlinedIcon />
              <span className={classes.fileName}>{file.name} <span className={classes.greyText}>- {(file.size / (1024 * 1024)).toFixed(2)} MB</span></span>
              <div style={{flexGrow: 1}} />
              <IconButton onClick={() => setFilesState([])}>
                <CloseOutlinedIcon />
              </IconButton>
            </div>
          ))
        ))}
        {(recentRejectedFile) && (
          [recentRejectedFile].map(({ file, errors }) => (
            <>
              <div className={clsx(classes.fileNameArea,classes.colorRed)} key={file.name}>
                <InsertDriveFileOutlinedIcon />
                <span className={classes.fileName}>{file.name} <span className={classes.greyText}>- {(file.size / (1024 * 1024)).toFixed(2)} MB</span></span>
                <div style={{flexGrow: 1}} />
                <IconButton
                  onClick={() => {
                    setFilesState([])
                    setRecentRejectedFile(null)
                  }}
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </div>
              {errors.map(({code}) => (
                <div className={clsx(classes.fileNameArea,classes.colorRed)}>
                  <span className={classes.colorRed}>{errorMessage(code)}</span>
                </div>
              ))}
            </>
          ))
        )}
      </div>
    </section>
  )
}

export default Uploader
